import React from 'react';
import cx from 'classnames';

import { string, bool } from 'prop-types';

const propTypes = {
  height: string,
  width: string,
  maxWidth: string,
  isCircle: bool,
};

const Skeleton = ({ height, width, maxWidth, isCircle }) => (
  <span
    className={cx('skeleton', isCircle ? 'is-circle' : '')}
    style={{ height, maxWidth, width, borderRadius: isCircle ? '50%' : 0 }}
  >
    &zwnj;
  </span>
);

Skeleton.propTypes = propTypes;

export default Skeleton;



// WEBPACK FOOTER //
// ./src/components/Skeleton/Skeleton.js